<template>
  <v-container>
    <v-row align="center">
      <v-spacer class="hidden-sm-and-down" />
      <div class="text-body-1 font-weight-light pt-6 pt-md-0 text-center">
        Made by
      </div>
      <v-col
        v-for="(link, i) in links"
        :key="i"
        class="text-center"
        cols="6"
        md="auto"
      >
        <a
          :href="link.href"
          class="text-decoration-none text-uppercase text-caption font-weight-regular"
          rel="noopener"
          target="_blank"
          v-text="link.text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Links',

    data: () => ({
      links: [
        {
          href: 'https://www.linkedin.com/in/jmharo/',
          text: 'J. Haro',
        },
        {
          href: 'https://www.linkedin.com/in/joonbaek0/',
          text: 'Joon Baek',
        },
      ],
    }),
  }
</script>

<style lang="sass" scoped>
  a
    color: inherit !important
</style>
